<template>
  <inline-descriptor
    :ref="'inlineDescriptor' + id"
    :id="id"
    :model-value="computedModel"
    @update:modelValue="onUpdateModelValue"
    :schema="computedSchema"
    :token-styles="computedTokenStyles"
    :bold-selected="boldSelected"
    :separators="separators"
    :update-token="customUpdateToken"
    :is-table="isTable"
    @update-menu="handleUpdateMenu"
    :enable-menu="isRoot"
    :is-root-level="isRoot"
    :createMode="createMode"
    :editable="editable"
    :plain-fields-open-menu="menuForPlainFields"
    :is-vertical="isVertical"
    :context-trigger="contextTrigger"
    :move-to-body="moveToBody"
    @reportWidths="onReportWidths"
    @add-list-item="addListItem"
    @remove-list-item="removeListItem"
    @clear-field="clearFieldValue"
    @add-value="addNewCreated"
    @title-action="$emit('title-action', $event)"
    :add-value-field-key="addValueFieldKey"
    :show-field-label="showFieldLabel"
    @blur="closeMenu"
    @keydown.up.exact.prevent="
      () => {
        if ($refs.aux_selector_def) {
          $refs.aux_selector_def.trackArrowUp(1);
        } else if ($refs.aux_selector_custom) {
          $refs.aux_selector_custom.trackArrowUp(1);
        }
      }
    "
    @keydown.down.exact.prevent="
      () => {
        if ($refs.aux_selector_def) {
          $refs.aux_selector_def.trackArrowDown(1);
        } else if ($refs.aux_selector_custom) {
          $refs.aux_selector_custom.trackArrowDown(1);
        }
      }
    "
    @keydown.enter.exact.prevent="
      () => {
        let didSelect = false;
        if ($refs.aux_selector_def) {
          didSelect = $refs.aux_selector_def.selectCurrent();
        } else if ($refs.aux_selector_custom) {
          didSelect = $refs.aux_selector_custom.selectCurrent();
        }
        if (didSelect) closeMenu();
      }
    "
    @keydown.esc.exact.prevent="closeMenu()"
  >
    <template #menu-content>
      <div
        class="parameter-inline-menu-row row no-wrap"
        :class="{ 'parameter-inline-menu-row--min-height-when-empty': showBothBlocksEmpty }"
      >
        <div
          v-if="
            editable &&
            isRoot &&
            templateId &&
            activeValueType === 4 &&
            templateId !== 999
          "
          class="parameter-inline-menu-col parameter-inline-menu-col--left"
          :class="{ 'parameter-inline-menu-col--left-no-header': templateId === 998 }"
        >
          <div
            class="parameter-inline-menu-col__header parameter-inline-menu-col__header--btn"
            v-if="templateId !== 998 && hintedSetTypeFromSelector !== undefined && (!sectionText || hintedSetTypeFromSelector !== V2ParameterValueSetExtensionType.Closed)"
            @click="addNewCreated"
          >
            <span class="parameter-inline-menu-col__header-text">{{ this.sectionText ? $t('add_value')+':' : $t('reset_value') }}&nbsp;{{ this.sectionText }}</span>
          </div>
          <div ref="leftSelectorWrapper" class="parameter-inline-menu-col__selector">
            <aux-selector
              ref="aux_selector_def"
              style="min-width: 300px"
              :filter-model-value="aux_filter_string"
              :input-index="0"
              :show-search-header="false"
              :limit-height-to-container="true"
              :container-height-px="leftSelectorHeightPx"
              :component-model="componentModel"
              :allow-free-input="false"
              :allow-multiple="true"
              :model-type="valueSetFromInstance ? 32 : 21"
              :set-id="templateId"
              :instance-id="instanceId || 0"
              :is-parameter-instance="!isRecordFieldInstance(instanceId || 0)"
              v-model="defhints"
              @hintedSetType="hintedSetTypeFromSelector = $event"
              @selectorClosed="closeMenu"
            />
          </div>
        </div>
        <div
          v-if="editable && isRoot && templateId !== 998 && (useCustomHints ? templateId !== 999 : showCustom)"
          v-show="rightSelectorHasData === true"
          class="parameter-inline-menu-col parameter-inline-menu-col--right"
        >
          <div class="parameter-inline-menu-col__header parameter-inline-menu-col__header--static">
            {{ useCustomHints ? $t('hints_label') : $t('positions_label') }}:
          </div>
          <div ref="rightSelectorWrapper" class="parameter-inline-menu-col__selector parameter-inline-menu-col__selector--right">
            <aux-selector
              ref="aux_selector_custom"
              class="parameter-inline-menu-col__selector-right"
              style="min-width: 30vw; max-width: 70vw"
              :container-height-px="rightSelectorHeightPx"
            :show-search-header="false"
            :limit-height-to-container="true"
            :filter-model-value="aux_filter_string"
            :allow-free-input="false"
            :allow-multiple="true"
            :component-model="componentModel"
            :model-type="useCustomHints ? 30 : 20"
            :input-index="0"
            :set-id="templateId"
            v-model="rightSelectorModel"
            @selectedHint="onCustomHintNotes"
            @selectorClosed="closeMenu"
            @dataAvailable="onRightSelectorDataAvailable"
          />
          </div>
        </div>
      </div>
    </template>
  </inline-descriptor>
</template>
<script lang="ts">
import { Component, Prop, Vue, Watch } from "vue-facing-decorator";
import { PropType, reactive, Component as vue_c, markRaw } from "vue";
import InlineDescriptor, { SchemaField, Token } from "./InlineDescriptor.vue";
import {
  V2ParameterValueSetExtensionType,
  V2ParameterValueSet_ValueType,
  V2ParameterValueType,
} from "@/models/etc/parameter-types";
import {
  ParameterInstance,
  ParameterInstanceContainer,
  ParameterInstanceContainerFilled,
} from "../../../models/interfaces/parameters/parameter-models";
import {
  ParameterInstanceContainerType,
  V2FieldValueDisplayType,
  V2RecordAxisType,
} from "../../../models/etc/types";
// import AuxSelector from "@/components/common/aux-selector/AuxSelector.vue";
import _, { debounce, first, last } from "lodash";
import { StorageItemSearched } from "../../../models/interfaces/storage/storage-models";
import { date } from "quasar";
import { parameterStore } from "../../../store/parameters/parameter-store";
import {
  isNumeric,
  isNumericFloat,
  createEmptyFromInstance,
  hasInstanceContainerStructureChanged,
  mapFilledContainerFromInstance,
  isInstanceContainerEmpty,
  resetInstanceValue
} from "../../../models/helpers/parameter-helpers";
import { findRecursive } from "../../../models/helpers/recursive";
import ParameterCheckbox from "./ParameterCheckbox.vue";
import { multiEditStore } from "../../../store/multiedit";
import ParameterDateField from "./ParameterDateField.vue";
import { CommonEntity } from "../../../models/interfaces/common";

/**
 * A component for displaying Record type
 */

const SPECIAL_TEMPLATE_IDS = new Set([998, 999]);

@Component({
  name: "ParameterInline",
  emits: [
    "update:modelValue",
    "update:nested",
    "storagePosChange",
    "reportWidths",
    "title-action",
  ],
  components: {
    InlineDescriptor,
    ParameterInline,
    ParameterCheckbox: markRaw(ParameterCheckbox),
    ParameterDateField: markRaw(ParameterDateField),
  },
  expose: ["rebuildSchema", "clearCurrentPositionMark"],
})
export default class ParameterInline extends Vue {
  @Prop({ type: String, required: true }) id!: string;
  @Prop({ type: Array, default: () => [] })
  modelValue!: ParameterInstanceContainer[];
  @Prop({ type: Object, default: () => ({}) }) tokenStyles!: Record<
    string,
    string
  >;
  @Prop({ type: String, default: "" }) indexPrefix!: string;
  @Prop({ type: Boolean, default: false }) editable!: boolean;
  @Prop({ type: Boolean, default: false }) isTable?: boolean;
  @Prop({ type: Boolean, default: false }) isRoot!: boolean;
  @Prop({ type: Boolean, default: true }) showFieldLabel!: boolean;
  @Prop({ type: Boolean, default: false }) moveToBody?: boolean;
  @Prop({ type: Boolean, default: true }) showCustom!: boolean;
  @Prop({ type: Boolean, default: false }) useVendorCode!: boolean;
  @Prop({ type: Boolean, default: false }) useStorageField!: boolean;
  @Prop({ type: Boolean, default: false }) isVertical!: boolean;
  @Prop({ type: Boolean, default: true }) createMode!: boolean;
  @Prop({ type: Boolean, default: false }) maintainStringValue!: boolean;
  @Prop({ type: Number, default: 0 }) storageForHint!: number;
  @Prop({ type: Boolean, default: false }) useCustomHints!: boolean;
  @Prop({ type: Boolean, default: false }) boldSelected!: boolean;
  // вне склада (страница проекта/клиента) набор значений грузится по вхождению через отдельную стратегию
  @Prop({ type: Boolean, default: false }) valueSetFromInstance!: boolean;
  // прокидывается InlineDescriptor в вложенно отрисованные компоненты; здесь не используется,
  // объявлен чтобы не падал в DOM-атрибуты при рендере вложенного ParameterInline в списке
  @Prop({ default: undefined }) nestedIndex?: number;
  // приходит от корневого экземпляра во вложенные; у корня пропа нет, он считает признак сам.
  // Без type: Boolean, иначе Vue приведёт отсутствующее значение к false и корень потеряет свой расчёт
  @Prop({ default: undefined }) plainFieldsOpenMenu?: boolean;

  @Prop({ type: Object as PropType<HTMLElement | null> })
  contextTrigger?: PropType<HTMLElement | null> = undefined;

  // Внутри класса компонента
  debouncedFilterUpdate!: any;

  // temporary
  positions: any[] = [];
  defhints: any[] = [];
  customHintsModel: any[] = [];
  customHintNotes: [number, { Id: number; Name: string }][] = [];

  get rightSelectorModel(): any[] {
    return this.useCustomHints ? this.customHintsModel : this.positions;
  }
  set rightSelectorModel(val: any[]) {
    if (this.useCustomHints) {
      this.customHintsModel = val;
    } else {
      this.positions = val;
    }
  }
  aux_filter_string: string = "";
  componentModel: {
    vendorCode: string;
    container: ParameterInstanceContainerFilled | null;
    isEmpty: boolean;
    storageForFilter?: number | null;
    possibleValueSetsIds?: number[];
  } = { vendorCode: "", isEmpty: true, container: null };

  parameter_store: any | undefined = undefined;
  multiedit_store: any | undefined = undefined;

  fieldKey: string | null = null;
  sectionText: string = "";
  // templateId of the current selected cell, it can change with focus
  templateId: number | undefined = undefined;
  activeNestedIndex: number | undefined = undefined;
  // templateId of the current selected cell, it can change with focus
  instanceId: number | undefined = undefined;
  activeValueType: number | undefined = undefined;

  /** HintedSetType от AuxSelector после загрузки Hints (undefined = ещё не пришли, null/число = пришли) */
  hintedSetTypeFromSelector: number | null | undefined = undefined;

  readonly V2ParameterValueSetExtensionType = V2ParameterValueSetExtensionType;

  /** Высота левого блока подсказки (для передачи в aux-selector), чтобы «все данные загружены» влезало */
  leftSelectorHeightPx: number = 0;
  /** Высота правого блока подсказки (для передачи в aux-selector), чтобы по высоте был стабилен */
  rightSelectorHeightPx: number = 0;
  /** null = ещё не загружено (показываем оптимистично), false = пусто, true = есть данные */
  rightSelectorHasData: boolean | null = null;
  private leftResizeObserver: ResizeObserver | null = null;
  private rightResizeObserver: ResizeObserver | null = null;

  /**
   * Режим поиска позиций, в котором меню открывается и для простых полей, а не только
   * для ValueSet (тот же предикат, что и при вызове openMenu ниже). Корню проп не приходит,
   * поэтому он считает признак по своим showCustom и useCustomHints, а вложенные берут
   * готовое значение корня, потому что меню открывает только корневой экземпляр.
   */
  get menuForPlainFields(): boolean {
    return this.plainFieldsOpenMenu ?? (this.showCustom && !this.useCustomHints);
  }

  get possibleValueSetsIds(): number[] {
    if (!this.useCustomHints) return [];
    const ids: number[] = [];
    const collectFromFields = (fields: ParameterInstanceContainer[]) => {
      for (const p of fields) {
        if (p.Instance?.ValueSet?.Id != null &&
            p.Instance.ValueType === V2ParameterValueType.ValueSet &&
            p.Instance.TemplateId !== this.templateId) {
          ids.push(p.Instance.ValueSet.Id);
        }
      }
    };
    for (const p of this.parameters) {
      if (p.Instance?.RecordFields?.length) {
        collectFromFields(p.Instance.RecordFields);
      }
      if (p.Instance?.ValueSet?.Id != null &&
          p.Instance.ValueType === V2ParameterValueType.ValueSet &&
          p.Instance.TemplateId !== this.templateId) {
        ids.push(p.Instance.ValueSet.Id);
      }
    }
    return [...new Set(ids)];
  }

  /** Оба столбца видимы и оба без данных — min-height только в этой подсказке; один блок или есть данные — контент определяет высоту. */
  get showBothBlocksEmpty(): boolean {
    if (!this.editable || !this.isRoot || !this.templateId || this.templateId === 998 || this.templateId === 999) return false;
    if (this.activeValueType !== 4) return false;
    if (!this.showCustom && !this.useCustomHints) return false;
    if ((this.defhints?.length ?? 0) > 0 || (this.positions?.length ?? 0) > 0) return false;
    return true;
  }

  get computedTokenStyles(): Record<string, string> {
    if (!this.boldSelected) return this.tokenStyles;
    const result: Record<string, string> = { ...this.tokenStyles };
    const prefix = this.indexPrefix;
    for (const param of this.parameters) {
      const ttl = param.ListTitle;
      const insts = param.Instance;
      if (param.Type === ParameterInstanceContainerType.List && ttl) {
        const templateId = ttl.Instances[0]?.TemplateId;
        ttl.Instances.forEach((item, i) => {
          if (item.SelectedValue?.Id > 0) {
            const key = `param_${templateId}_${prefix}${i}`;
            result[key] = (result[key] ? result[key] + '; ' : '') + 'font-weight: 500';
          }
        });
      } else if (insts) {
        if (insts.SelectedValue?.Id > 0) {
          const key = `param_${insts.TemplateId}_${prefix}`;
          result[key] = (result[key] ? result[key] + '; ' : '') + 'font-weight: 500';
        }
      }
    }
    return result;
  }

  computedSchema: SchemaField[] = reactive([]);

  // Структура, из которой построена текущая схема. Нужна как база сравнения: живой
  // this.parameters к моменту проверки может быть уже синхронен пришедшей модели, и тогда
  // изменение становится невидимым, а схема остаётся от прежней структуры
  private schemaSource: ParameterInstanceContainer[] = [];

  private schemaRebuildScheduled = false;
  computedModel: Record<string, any> = reactive({});
  componentStorageValue: any = null;

  // in storage items mode this is the currently selected one
  currentStoragePos: any = {
    currentPosId: 0,
    currentPosPrice: 0,
    currentPosPriceType: 0,
    currentPosUnit: 0,
    currentPosStorages: [],
  };

  // table column widths
  pending: { templateId: string; width: number }[] = [];
  // scheduled = false;
  stableTimer: any = null;
  selectedValueCache: any = null;

  private separators = [","];
  parameters = reactive<ParameterInstanceContainer[]>(
    Array.isArray(this.modelValue) ? this.modelValue : []
  );

  private getMainParam(): ParameterInstanceContainer | undefined {
    const idx = this.useVendorCode ? 1 : 0;
    const param = this.parameters[idx];
    if (!param) return undefined;
    const tid = param.Instance?.TemplateId;
    if (tid != null && SPECIAL_TEMPLATE_IDS.has(tid)) return undefined;
    return param;
  }

  created() {
    this.parameter_store = parameterStore();
    this.multiedit_store = multiEditStore();
  }

  mounted() {
    this.parameters = reactive<ParameterInstanceContainer[]>(
      Array.isArray(this.modelValue) ? this.modelValue : []
    );
    this.rebuildSchema();
    this.computedModel = reactive(
      this.createModelValue(this.parameters, this.indexPrefix)
    );
    if (this.isRoot) {
      const mainParam = this.getMainParam();
      const cont = mainParam
        ? mapFilledContainerFromInstance([_.cloneDeep(mainParam)], true)[0]
        : null;
      this.componentModel = reactive({
        vendorCode: this.parameters[0]?.Instance?.StringValue || "",
        container: cont,
        isEmpty: mainParam ? isInstanceContainerEmpty(mainParam) : true,
        storageForFilter: this.useStorageField ? this.componentStorageValue?.Id : this.storageForHint,
        possibleValueSetsIds: this.useCustomHints ? this.possibleValueSetsIds : undefined,
      });
    }

    this.debouncedFilterUpdate = debounce(() => this.applyFilterUpdate(), 300);
  }

  /** Нормализация контейнера для сравнения: только TemplateId, StringValue, ValueOfSet, RecordFields (mapFilledContainerFromInstance не выдаёт NumberValue/BoolValue/DateValue). */
  private normalizeContainerForFilterCompare(c: ParameterInstanceContainerFilled | null | undefined): ParameterInstanceContainerFilled | null {
    if (c == null) return null;
    const recordFields = (c.RecordFields || [])
      .map((f) => this.normalizeContainerForFilterCompare(f))
      .filter((x): x is ParameterInstanceContainerFilled => x != null);
    return {
      TemplateId: c.TemplateId,
      StringValue: c.StringValue,
      ValueOfSet: c.ValueOfSet,
      RecordFields: recordFields,
    };
  }

  /** Обновление фильтра (aux_filter_string, componentModel). При смене секции вызываем напрямую, чтобы не давать второй вызов через debounce. */
  applyFilterUpdate() {
    if (!this.isRoot) { return }
    if (this.aux_filter_string != this.sectionText) {
      this.aux_filter_string = this.sectionText;
      if (this.componentModel && this.templateId === 999) {
        this.componentModel.vendorCode = this.sectionText;
      }
    }

    const cont = this.componentModel.container
    const mainParam = this.getMainParam();
    const cont_new = mainParam
      ? mapFilledContainerFromInstance([_.cloneDeep(mainParam)], true)[0]
      : null;

    if (
      this.componentModel.vendorCode !=
        (this.parameters[0]?.Instance?.StringValue || "") ||
      !_.isEqual(cont, cont_new) ||
      this.componentModel.storageForFilter != (this.useStorageField ? this.componentStorageValue?.Id : this.storageForHint)
      ) {
        this.componentModel = reactive({
        vendorCode: this.parameters[0]?.Instance?.StringValue || "",
        container: cont_new,
        isEmpty: mainParam ? isInstanceContainerEmpty(mainParam) : true,
        storageForFilter: this.useStorageField ? this.componentStorageValue?.Id : this.storageForHint,
        possibleValueSetsIds: this.useCustomHints ? this.possibleValueSetsIds : undefined,
      });
    }
  }

  onReportWidths(widthArray: any[]) {
    if (this.isRoot && this.editable) {
      // this.pending.push(...widthArray);

      // if (!this.scheduled) {
      //   this.scheduled = true;
      //   requestAnimationFrame(this.commitWidths);
      // }

      this.pending.push(...widthArray);
      // Сбрасываем прошлый таймер
      clearTimeout(this.stableTimer);
      // Запускаем новый — “ждём пока всё утихнет”
      // this.stableTimer = setTimeout(() => this.commitWidths(), 500);
    } else {
      this.$emit("reportWidths", widthArray);
    }
  }

  // Схема не опустошается перед сборкой. Пустая схема это отдельное срабатывание вотчера
  // в inline-descriptor, то есть лишний проход и кадр с пустой разметкой, от которого
  // уезжает прокрутка в прокручиваемом предке.
  //
  // Повторные вызовы в одном такте не копятся. Внешняя смена модели идёт несколькими
  // правками подряд, каждая будит вотчер, и вдобавок снаружи зовут этот метод руками.
  // Сборка схемы на большом дереве дорогая, а каждое присваивание это ещё и проход
  // в inline-descriptor, поэтому хватает одной сборки по итоговой модели
  rebuildSchema() {
    if (this.schemaRebuildScheduled) {
      return;
    }
    this.schemaRebuildScheduled = true;

    const that = this;
    this.$nextTick(() => {
      that.schemaRebuildScheduled = false;
      that.computedSchema = reactive(
        that.createSchema(that.parameters, that.indexPrefix)
      );
      that.schemaSource = _.cloneDeep(that.parameters);
    });
  }

  commitWidths() {
    if (!this.editable) {
      return;
    }
    const maxByTemplate = new Map<string, number>();

    for (const { templateId, width } of this.pending) {
      const prev = maxByTemplate.get(templateId) || 0;
      if (width > prev) maxByTemplate.set(templateId, width);
    }

    this.pending.length = 0;
    // this.scheduled = false;

    const inlineDescriptor = this.$refs["inlineDescriptor" + this.id] as any;
    if (inlineDescriptor) {
      // Ищем все td внутри компонента
      const tds = inlineDescriptor.$el.querySelectorAll("td[data-template-id]");
      tds.forEach((td: any) => {
        const templateId = td.getAttribute("data-template-id")!;
        (td as HTMLElement).style.width = `var(--w-${templateId})`;
        (td as HTMLElement).style.minWidth = `var(--w-${templateId})`;
        (td as HTMLElement).style.maxWidth = `var(--w-${templateId})`;
      });
    }

    // Записываем CSS custom props
    const root = document.documentElement;
    for (const [templateId, width] of maxByTemplate.entries()) {
      root.style.setProperty(`--w-${templateId}`, `${width}px`);
    }
  }

  @Watch("modelValue", { deep: true })
  onModelValueChange(newValue: ParameterInstanceContainer[]) {
    if (!this.debouncedFilterUpdate || !this.modelValue) { return }

    const structureChanged = hasInstanceContainerStructureChanged(
      this.schemaSource,
      newValue
    );

    this.parameters.splice(
      0,
      this.parameters.length,
      ...reactive<ParameterInstanceContainer[]>(
        Array.isArray(newValue) ? newValue : []
      )
    );

    this.computedModel = reactive(
      this.createModelValue(this.parameters, this.indexPrefix)
    );

    // Схему перестраивает тот уровень, до которого дошла новая модель, а не только
    // корневой. Сверка в inline-descriptor сохраняет узлы, значит вложенный уровень
    // больше не пересоздаётся сверху и свою схему должен обновить сам.
    //
    // Раньше, чем изменение дойдёт до корня, это не случится: наверх уходит событие,
    // а своя модель меняется только когда пропом вернётся обработанная. Сравнение идёт
    // со структурой, из которой построена текущая схема, поэтому уровень берётся за
    // работу лишь тогда, когда у него самого правда изменилась структура
    if (!this.computedSchema.length || structureChanged) {
      this.rebuildSchema();
    }

    if (this.useStorageField && this.parameters && this.parameters.length) {
      const last_cell = this.parameters[this.parameters.length-1];
      if (last_cell.Type === ParameterInstanceContainerType.SingleInstance && last_cell.Instance?.TemplateId === 998) {
        this.componentStorageValue = last_cell.Instance?.SelectedValue;
      }
    }

    if (this.isRoot) {
      const mainParam = this.getMainParam();
      const cont_new = mainParam
        ? mapFilledContainerFromInstance([_.cloneDeep(mainParam)], true)[0]
        : null;
      const vendorCode = this.parameters[0]?.Instance?.StringValue || "";
      const storageForFilter = this.useStorageField ? this.componentStorageValue?.Id : this.storageForHint;
      const eqStr = this.aux_filter_string === this.sectionText;
      const eqVendor = this.componentModel.vendorCode === vendorCode;
      const eqCont = _.isEqual(this.componentModel.container, cont_new);
      const eqContNormalized = _.isEqual(
        this.normalizeContainerForFilterCompare(this.componentModel.container),
        this.normalizeContainerForFilterCompare(cont_new)
      );
      const eqStorage = this.componentModel.storageForFilter === storageForFilter;
      const filterUnchanged = eqStr && eqVendor && (eqCont || eqContNormalized) && eqStorage;
      if (!filterUnchanged) {
        this.$nextTick(() => {
          this.debouncedFilterUpdate();
          this.defhints.splice(0);
          this.positions.splice(0);
        });
      }
    }
  }

  @Watch("customHintsModel")
  customHintsModel_watcher() {
    if (!this.customHintsModel.length) return;
    this.defhints = [...this.customHintsModel];
    this.customHintsModel.splice(0);
  }

  onCustomHintNotes(notes: [number, { Id: number; Name: string }][]) {
    this.customHintNotes = notes;
  }

  onRightSelectorDataAvailable(hasData: boolean) {
    this.rightSelectorHasData = hasData;
  }

  @Watch("positions")
  positions_watcher() {
    if (!this.positions.length) {
      return;
    }
    const res = (this.positions[0] as StorageItemSearched).NameParameters;
    let newParameters = _.cloneDeep(this.parameters);

    const params_arr = [...res]

    if (this.useVendorCode) {
      const vcode_cell = {
        Type: ParameterInstanceContainerType.SingleInstance,
        Instance: {
          TemplateId: 999,
          Unremovable: true,
          ValueType: V2ParameterValueType.String,
          StringValue: (this.positions[0] as StorageItemSearched).VendorCode,
          NumberValue: null,
          DateValue: null,
          BoolValue: null,
          ValueSet: null,
          SelectedValue: null,
          ValueDisplayType: V2FieldValueDisplayType.Inline,
          Name: this.$t('sku'),
          Id: 0,
          Round: 2,
          RecordAxisType: V2RecordAxisType.Horizontal,
          RecordFields: [],
        } as ParameterInstance,
        ListTitle: null,
      } as ParameterInstanceContainer;
      params_arr.splice(0, 0, vcode_cell);
    }

    if (this.useStorageField) {
      const storage_cell = {
        Type: ParameterInstanceContainerType.SingleInstance,
        Instance: {
          TemplateId: 998,
          Unremovable: true,
          ValueType: V2ParameterValueType.ValueSet,
          StringValue: '',
          NumberValue: null,
          DateValue: null,
          BoolValue: null,
          ValueSet: {
            Id: 998,
            Name: this.$t('warehouse'),
            StringName: '',
            ValueType: V2ParameterValueSet_ValueType.String
          },
          SelectedValue: this.componentStorageValue,
          ValueDisplayType: V2FieldValueDisplayType.Inline,
          Name: this.$t('warehouse'),
          Id: 0,
          Round: 2,
          RecordAxisType: V2RecordAxisType.Horizontal,
          RecordFields: [],
        } as ParameterInstance,
        ListTitle: null,
      } as ParameterInstanceContainer;
      params_arr.push(storage_cell);
    }
    newParameters = reactive(params_arr);

    this.currentStoragePos = {
      currentPosId: (this.positions[0] as StorageItemSearched).Id,
      currentPosPrice: (this.positions[0] as StorageItemSearched).Price,
      currentPosPriceType: (this.positions[0] as StorageItemSearched).PriceType,
      currentPosUnit: (this.positions[0] as StorageItemSearched).MeasureUnit.Id,
      currentPosStorages: (this.positions[0] as StorageItemSearched)
        .QuantitiesInStock,
    };
    this.unsetWidths();

    this.$emit("storagePosChange", this.currentStoragePos);
    this.$emit("update:modelValue", newParameters); // this.parameters
    this.positions.splice(0);
    this.closeMenu();
  }

  // tid и id по умолчанию берутся у активного поля. Явные значения нужны там, где
  // действие приходит не от активного поля, например по значку очистки в чужой ячейке.
  currentTemplateParam(
    model: ParameterInstanceContainer[],
    tid: number | undefined = this.templateId,
    id: number | undefined = this.instanceId
  ): ParameterInstanceContainer {
    if (this.isRoot) {
      // console.log('look for TemplateParam by:');
      // console.log({ tid: this.templateId, id: this.instanceId });
    }
    return findRecursive(
      function a(
        element: ParameterInstanceContainer,
        el_to_find: any
      ): any | undefined {
        if (!element) return undefined;
        if (
          element.Type === ParameterInstanceContainerType.SingleInstance &&
          element.Instance
        ) {
          if (
            el_to_find.tid == element.Instance?.TemplateId &&
            el_to_find.id == element.Instance?.Id
          ) {
            return element;
          }
          if (element.Instance.ValueType === V2ParameterValueType.Record) {
            const found_el = findRecursive(
              a,
              el_to_find,
              element.Instance.RecordFields
            );
            if (found_el) {
              return found_el;
            }
          }
        } else if (
          element.Type === ParameterInstanceContainerType.List &&
          element.ListTitle
        ) {
          for (let pi = 0; pi < element.ListTitle.Instances.length; pi++) {
            const el = element.ListTitle.Instances[pi];
            if (!el) return undefined;

            if (el_to_find.tid == el.TemplateId && el_to_find.id == el.Id) {
              return element;
            }
            if (el.ValueType === V2ParameterValueType.Record) {
              const found_el = findRecursive(a, el_to_find, el.RecordFields);
              if (found_el) {
                return found_el;
              }
            }
          }
        }

        return undefined;
      },
      { tid, id },
      model
    );
  }

  /**
   * Очистка значения по значку в поле.
   *
   * Отдельный канал, а не новое значение eventKind у update-menu: там есть ветки вида
   * «всё, что не 0 и не 1», в которые новое значение провалилось бы и открыло меню,
   * в том числе у стороннего слушателя этого же события.
   *
   * Правка идёт по месту в this.parameters, а не по клону: clearCurrentPositionMark
   * ниже сам клонирует this.parameters и эмитит результат, и на клоне очистка
   * откатилась бы обратно.
   */
  clearFieldValue(payload: {
    fieldKey: string;
    nestedIndex: string | undefined;
    opts: any | undefined;
  }) {
    const tid = payload.opts?.TemplateId;
    const id = payload.opts?.InstanceId;
    if (tid === undefined || id === undefined) {
      return;
    }

    const templateParam = this.currentTemplateParam(this.parameters, tid, id);
    if (!templateParam) {
      return;
    }

    const nested =
      payload.nestedIndex !== undefined ? Number(payload.nestedIndex) : undefined;
    const inst =
      templateParam.Type === ParameterInstanceContainerType.List &&
      templateParam.ListTitle &&
      nested !== undefined
        ? templateParam.ListTitle.Instances[nested]
        : templateParam.Instance;

    if (!inst) {
      return;
    }

    resetInstanceValue(inst);
    this.selectedValueCache = null;

    this.$emit("update:modelValue", reactive(_.cloneDeep(this.parameters)));
    this.clearCurrentPositionMark();

    // В режиме создания запрос не уйдёт: editFieldValueRequest выходит по createMode.
    if (inst.Id > 0) {
      this.editFieldValueRequest(inst.Id, this.getEditRequest(inst));
    }
  }

  /**
   * Ключ поля, которому сейчас доступно добавление значения в набор. Условия те же, что
   * у кнопки в подсказке: открытое множество, тип ValueSet и непустой введённый текст.
   */
  get addValueFieldKey(): string | undefined {
    if (!this.isRoot || !this.editable || !this.fieldKey) return undefined;
    if (!this.templateId || this.templateId === 999 || this.templateId === 998) {
      return undefined;
    }
    if (this.activeValueType !== V2ParameterValueType.ValueSet) return undefined;
    if (this.hintedSetTypeFromSelector === undefined) return undefined;
    if (
      this.hintedSetTypeFromSelector ===
      V2ParameterValueSetExtensionType.Closed
    ) {
      return undefined;
    }
    if (!this.sectionText) return undefined;

    return this.fieldKey;
  }

  private findInstanceByValueSetId(containers: ParameterInstanceContainer[], valueSetId: number): ParameterInstance | null {
    for (const p of containers) {
      if (p.Type === ParameterInstanceContainerType.SingleInstance && p.Instance) {
        if (p.Instance.ValueSet?.Id === valueSetId && p.Instance.ValueType === V2ParameterValueType.ValueSet) {
          return p.Instance;
        }
        if (p.Instance.ValueType === V2ParameterValueType.Record && p.Instance.RecordFields?.length) {
          const found = this.findInstanceByValueSetId(p.Instance.RecordFields, valueSetId);
          if (found) return found;
        }
      } else if (p.Type === ParameterInstanceContainerType.List && p.ListTitle) {
        for (const inst of p.ListTitle.Instances) {
          if (inst?.ValueSet?.Id === valueSetId && inst.ValueType === V2ParameterValueType.ValueSet) {
            return inst;
          }
          if (inst?.ValueType === V2ParameterValueType.Record && inst.RecordFields?.length) {
            const found = this.findInstanceByValueSetId(inst.RecordFields, valueSetId);
            if (found) return found;
          }
        }
      }
    }
    return null;
  }

  @Watch("defhints")
  default_watcher() {
    if (!this.defhints.length || !this.templateId) {
      return;
    }
    const newParameters = reactive(_.cloneDeep(this.parameters));

    // set selected parameter on selection in the root component
    if (this.isRoot) {
      const templateParam: ParameterInstanceContainer =
        this.currentTemplateParam(newParameters);

      if (!templateParam) {
        return;
      }

      const ttl = templateParam.ListTitle;
      const insts = templateParam.Instance;

      if (
        templateParam.Type === ParameterInstanceContainerType.List &&
        ttl &&
        this.activeNestedIndex
      ) {
        const firstInstance = ttl.Instances[this.activeNestedIndex];
        if (firstInstance) {
          firstInstance.SelectedValue = this.defhints[0];
          firstInstance.StringValue = (this.defhints[0] as CommonEntity).Name;
          this.selectedValueCache = this.defhints[0];

          if (this.templateId === 998) {
            this.componentStorageValue = this.defhints[0];
          } else {
            // очистить позицию если это не поле фильтра склада
            this.clearCurrentPositionMark();
          }
        }

        // make API call
        if (firstInstance && firstInstance.Id > 0) {
          this.editFieldValueRequest(
            firstInstance.Id,
            this.getEditRequest(firstInstance)
          );
        }
      } else if (
        templateParam.Type === ParameterInstanceContainerType.SingleInstance &&
        insts
      ) {
        insts.SelectedValue = this.defhints[0];
        insts.StringValue = (this.defhints[0] as CommonEntity).Name;
        this.selectedValueCache = this.defhints[0];
        if (this.templateId === 998) {
          this.componentStorageValue = this.defhints[0];
        } else {
          // очистить позицию если это не поле фильтра склада
          if (this.templateId !== 999) {
            this.componentModel.vendorCode = "";
            if (
              newParameters &&
              newParameters[0] &&
              newParameters[0].Instance
            ) {
              newParameters[0].Instance.StringValue = "";
            }
            this.clearCurrentPositionMark();
          }
        }

        // make API call
        if (insts.Id > 0) {
          this.editFieldValueRequest(insts.Id, this.getEditRequest(insts));
        }
      }

      // Fill sibling fields from custom hint notes (analog of Angular SelectField)
      if (this.customHintNotes.length > 0) {
        for (const [valueSetId, val] of this.customHintNotes) {
          const inst = this.findInstanceByValueSetId(newParameters, valueSetId);
          if (inst) {
            inst.SelectedValue = { Id: val.Id, Name: val.Name };
            inst.StringValue = val.Name;
            if (inst.Id > 0) {
              this.editFieldValueRequest(inst.Id, this.getEditRequest(inst));
            }
          }
        }
        this.customHintNotes = [];
      }

      this.unsetWidths();
      this.$emit("update:modelValue", newParameters); // this.parameters
    }

    this.defhints.splice(0);
    this.closeMenu();
  }

  unsetWidths() {
    const inlineDescriptor = this.$refs["inlineDescriptor" + this.id] as any;
    if (inlineDescriptor) {
      // Ищем все td внутри компонента
      const tds = inlineDescriptor.$el.querySelectorAll("td[data-template-id]");
      tds.forEach((td: any) => {
        (td as HTMLElement).style.width = `unset`;
        (td as HTMLElement).style.minWidth = `unset`;
        (td as HTMLElement).style.maxWidth = `unset`;
      });
    }
  }

  addNewCreated() {
    this.closeMenu();
    this.selectedValueCache = null;

    if (!this.parameters) {
      return;
    }

    const templateParam: ParameterInstanceContainer = this.currentTemplateParam(
      this.parameters
    );
    if (!templateParam) {
      return;
    }

    const ttl = templateParam.ListTitle;
    const insts = templateParam.Instance;

    if (
      templateParam.Type === ParameterInstanceContainerType.List &&
      ttl &&
      this.activeNestedIndex
    ) {
      const firstInstance = ttl.Instances[this.activeNestedIndex];
      // make API call
      if (firstInstance) {
        if (firstInstance.Id > 0) {
          this.editFieldValueRequest(
            firstInstance.Id,
            this.getEditRequest(firstInstance)
          );
        } else {
          if (!this.sectionText) {
            firstInstance.SelectedValue = null;
            firstInstance.StringValue = '';
            this.selectedValueCache = null;
            this.$emit("update:modelValue", reactive(_.cloneDeep(this.parameters)));
            this.clearCurrentPositionMark();
            return;
          }
          firstInstance.SelectedValue = {
            Id: undefined,
            Name: this.sectionText,
          };
          firstInstance.StringValue = this.sectionText;
        }
      }
    } else if (
      templateParam.Type === ParameterInstanceContainerType.SingleInstance &&
      insts
    ) {
      // make API call
      if (insts.Id > 0) {
        this.editFieldValueRequest(insts.Id, this.getEditRequest(insts));
      } else {
        if (!this.sectionText) {
          insts.SelectedValue = null;
          insts.StringValue = '';
          this.selectedValueCache = null;
          this.$emit("update:modelValue", reactive(_.cloneDeep(this.parameters)));
          this.clearCurrentPositionMark();
          return;
        }
        insts.SelectedValue = {
          Id: undefined,
          Name: this.sectionText,
        };
        insts.StringValue = this.sectionText;
      }
    }

    this.clearCurrentPositionMark();
  }

  /** Резерв снизу под «все данные загружены»: меньше, если нет кнопки/заголовка (только в этой подсказке). */
  private get leftReservePx(): number {
    return this.templateId === 998 ? 12 : 16;
  }
  private get rightReservePx(): number {
    return this.templateId === 998 ? 20 : 16;
  }

  /** Обновляет leftSelectorHeightPx по текущей высоте обёртки (вызывается при открытии и при изменении размера). */
  updateLeftSelectorHeightPx() {
    const el = this.$refs.leftSelectorWrapper as HTMLElement | undefined;
    if (el) {
      const h = el.offsetHeight;
      this.leftSelectorHeightPx = Math.max(0, h - this.leftReservePx);
    } else {
      this.leftSelectorHeightPx = 0;
    }
  }

  /** Обновляет rightSelectorHeightPx по текущей высоте обёртки. */
  updateRightSelectorHeightPx() {
    const el = this.$refs.rightSelectorWrapper as HTMLElement | undefined;
    if (el) {
      this.rightSelectorHeightPx = Math.max(0, el.offsetHeight - this.rightReservePx);
    } else {
      this.rightSelectorHeightPx = 0;
    }
  }

  /** Измеряет высоту левого блока подсказки (сразу, повторно после загрузки, и по ResizeObserver). */
  measureLeftSelectorHeight() {
    this.$nextTick(() => {
      setTimeout(() => {
        this.updateLeftSelectorHeightPx();
        const el = this.$refs.leftSelectorWrapper as HTMLElement | undefined;
        if (el) {
          this.leftResizeObserver?.disconnect();
          this.leftResizeObserver = new ResizeObserver(() => {
          requestAnimationFrame(() => this.updateLeftSelectorHeightPx());
        });
          this.leftResizeObserver.observe(el);
        }
      }, 50);
      setTimeout(() => this.updateLeftSelectorHeightPx(), 450);
    });
  }

  /** Измеряет высоту правого блока подсказки (сразу, повторно после загрузки, и по ResizeObserver). */
  measureRightSelectorHeight() {
    this.$nextTick(() => {
      setTimeout(() => {
        this.updateRightSelectorHeightPx();
        const el = this.$refs.rightSelectorWrapper as HTMLElement | undefined;
        if (el) {
          this.rightResizeObserver?.disconnect();
          this.rightResizeObserver = new ResizeObserver(() => {
          requestAnimationFrame(() => this.updateRightSelectorHeightPx());
        });
          this.rightResizeObserver.observe(el);
        }
      }, 50);
      setTimeout(() => this.updateRightSelectorHeightPx(), 450);
    });
  }

  beforeUnmount() {
    this.leftResizeObserver?.disconnect();
    this.rightResizeObserver?.disconnect();
  }

  handleUpdateMenu(value: {
    fieldKey: string | null;
    sectionText: string;
    eventKind: number;
    opts: any | undefined;
    nestedIndex: number | undefined;
  }) {
    const sectionChanged =
      this.templateId !== value.opts?.TemplateId ||
      this.activeNestedIndex !== value.nestedIndex;

    const newParameters = reactive(_.cloneDeep(this.parameters));

    if (sectionChanged && this.selectedValueCache && this.isRoot) {
      const oldTemplateParam = this.currentTemplateParam(newParameters);
      if (oldTemplateParam) {
        const ttl = oldTemplateParam.ListTitle;
        const insts = oldTemplateParam.Instance;
        if (
          oldTemplateParam.Type === ParameterInstanceContainerType.List &&
          ttl && this.activeNestedIndex
        ) {
          const inst = ttl.Instances[this.activeNestedIndex];
          if (inst) {
            inst.SelectedValue = this.selectedValueCache;
            inst.StringValue = "";
          }
        } else if (
          oldTemplateParam.Type === ParameterInstanceContainerType.SingleInstance &&
          insts
        ) {
          insts.SelectedValue = this.selectedValueCache;
          insts.StringValue = "";
        }
        this.selectedValueCache = null;
      }
    }

    this.fieldKey = value.fieldKey;
    this.sectionText = value.sectionText;
    this.templateId = value.opts?.TemplateId;
    this.activeNestedIndex = value.nestedIndex;
    this.instanceId = value.opts?.InstanceId;
    this.activeValueType = value.opts?.ValueType;
    if (sectionChanged) {
      this.hintedSetTypeFromSelector = undefined;
      this.rightSelectorHasData = null;
    }

    if (this.templateId && this.templateId !== 999 && this.activeValueType === 4) {
      this.measureLeftSelectorHeight();
    } else {
      this.leftSelectorHeightPx = 0;
    }
    if ((this.showCustom || this.useCustomHints) && this.templateId !== 998) {
      this.measureRightSelectorHeight();
    } else {
      this.rightSelectorHeightPx = 0;
    }

    // Ввод текста (input): только планируем дебаунс 300 мс
    if (this.isRoot && this.debouncedFilterUpdate && value.eventKind === 0) {
      this.debouncedFilterUpdate();
    }

    if (this.isRoot) {
      this.$nextTick(() => {
        // Смена секции / открытие меню: сперва обновляем фильтр, потом открываем меню — селекторы получат уже актуальный фильтр
        if (value.eventKind !== 0 && value.eventKind !== 1) {
          this.debouncedFilterUpdate?.cancel();
          this.applyFilterUpdate();
        }
        const inlineDescriptor = this.$refs[
          "inlineDescriptor" + this.id
        ] as any;
        if (inlineDescriptor) {
          this.unsetWidths();

          if (value.eventKind === 1) {
            inlineDescriptor.hideMenu();
            this.componentModel.container = null;

            // обработка события blur на меню. Если maintainStringValue, либо это служебное поле (например, артикул) или не ValueSet,
            // то нужно закрепить StringValue в модели и обнулить SelectedValue, иначе надо оставить выбранное значение (пользователь
            // использовал StringValue лишь в качестве фильтра и не выбрал ничего иного, либо выбрал из подсказок в методах defhints, positions)
            // и теперь StringValue нужно вернуть на это значение, либо очистить если SelectedValue не выбрано
            const templateParam: ParameterInstanceContainer =
              this.currentTemplateParam(newParameters);
            if (!templateParam) {
              return;
            }

            const ttl = templateParam.ListTitle;
            const insts = templateParam.Instance;

            // инстанс, который коммитим по blur (число): нужен для editField после единственного emit
            let committedInst: ParameterInstance | undefined;

            if (
              templateParam.Type === ParameterInstanceContainerType.List &&
              ttl &&
              this.activeNestedIndex != null
            ) {
              const firstInstance = ttl.Instances[this.activeNestedIndex];
              if (firstInstance) {
                if (
                  this.maintainStringValue ||
                  (this.templateId === 999 ||
                    !value.opts ||
                    this.activeValueType !== V2ParameterValueType.ValueSet)
                ) {
                  firstInstance.SelectedValue = this.selectedValueCache ?? null;
                } else {
                  firstInstance.SelectedValue = this.selectedValueCache;
                  firstInstance.StringValue = "";
                }
                this.selectedValueCache = null;
                // число: свежее значение берём прямо из события (value.sectionText),
                // клон this.parameters на этот момент может быть устаревшим
                if (
                  firstInstance.ValueType === V2ParameterValueType.Int ||
                  firstInstance.ValueType === V2ParameterValueType.Double
                ) {
                  firstInstance.NumberValue = this.ParameterInstanceFromValue(
                    firstInstance,
                    value.sectionText
                  ).NumberValue;
                }
                committedInst = firstInstance;
              }
            } else if (
              templateParam.Type ===
                ParameterInstanceContainerType.SingleInstance &&
              insts
            ) {
              if (
                this.maintainStringValue ||
                (this.templateId === 999 ||
                  !value.opts ||
                  this.activeValueType !== V2ParameterValueType.ValueSet)
              ) {
                insts.SelectedValue = this.selectedValueCache ?? null;
              } else {
                insts.SelectedValue = this.selectedValueCache;
                insts.StringValue = "";
              }
              this.selectedValueCache = null;
              if (
                insts.ValueType === V2ParameterValueType.Int ||
                insts.ValueType === V2ParameterValueType.Double
              ) {
                insts.NumberValue = this.ParameterInstanceFromValue(
                  insts,
                  value.sectionText
                ).NumberValue;
              }
              committedInst = insts;
            }

            // emit model value so that the parent has actual state
            this.$emit("update:modelValue", newParameters);

            // персист элементарного значения в edit: emit выше единственный, тут только запрос.
            // В create это no-op (Id <= 0). Чистая String идёт этой же веткой (подсказок у неё нет),
            // кроме поисковых фильтров 999/998 - их PATCHить нельзя.
            if (
              committedInst &&
              committedInst.Id > 0 &&
              (committedInst.ValueType === V2ParameterValueType.Int ||
                committedInst.ValueType === V2ParameterValueType.Double ||
                (committedInst.ValueType === V2ParameterValueType.String &&
                  this.templateId !== 999 &&
                  this.templateId !== 998))
            ) {
              this.editFieldValueRequest(
                committedInst.Id,
                this.getEditRequest(committedInst)
              );
            }
          } else {
            // ValueSet-подсказки открываем всегда; режим поиска позиций (showCustom без
            // useCustomHints) - тоже по всем полям, как и раньше. А в useCustomHints
            // (кастомные подсказки) простые текстовые/числовые поля меню не открывают.
            const isValueSetField =
              this.templateId !== 999 &&
              value.opts &&
              this.activeValueType === V2ParameterValueType.ValueSet;
            const positionsSearchMode = this.showCustom && !this.useCustomHints;
            if (isValueSetField || positionsSearchMode) {
              const positionTarget = (this.showCustom || this.useCustomHints) && this.templateId !== 998 ? "container" : "section";
              inlineDescriptor.openMenu(positionTarget);
            }

            // обработка события input. Если maintainStringValue, либо это служебное поле (например, артикул) или не ValueSet,
            // то нужно обновлять StringValue в модели
            // if (newParameters) {
              // clear selected value as text input event occurred
              const templateParam: ParameterInstanceContainer =
                this.currentTemplateParam(newParameters);
              if (!templateParam) {
                return;
              }

              const ttl = templateParam.ListTitle;
              const insts = templateParam.Instance;

              // инстанс, который коммитим на изменение (Bool/Date, eventKind=2)
              let committedInst: ParameterInstance | undefined;

              if (
                templateParam.Type === ParameterInstanceContainerType.List &&
                ttl &&
                this.activeNestedIndex != null
              ) {
                const firstInstance = ttl.Instances[this.activeNestedIndex];
                if (firstInstance) {
                  if (
                    !this.maintainStringValue &&
                    (this.templateId !== 999 &&
                      value.opts &&
                      this.activeValueType === V2ParameterValueType.ValueSet)
                  ) {
                    if (firstInstance.SelectedValue) {
                      this.selectedValueCache = _.cloneDeep(firstInstance.SelectedValue);
                    }
                  }
                  if (value.eventKind === 0) {
                    firstInstance.StringValue = value.sectionText;
                    firstInstance.SelectedValue = null;
                  }
                  // Bool/Date коммитятся на изменение (eventKind=2), значение из события
                  if (value.eventKind === 2) {
                    if (firstInstance.ValueType === V2ParameterValueType.Bool) {
                      firstInstance.BoolValue = this.ParameterInstanceFromValue(
                        firstInstance,
                        value.sectionText
                      ).BoolValue;
                    } else if (firstInstance.ValueType === V2ParameterValueType.Date) {
                      firstInstance.DateValue = value.sectionText
                        ? new Date(value.sectionText)
                        : null;
                    }
                  }
                  committedInst = firstInstance;
                }
              } else if (
                templateParam.Type ===
                  ParameterInstanceContainerType.SingleInstance &&
                insts
              ) {
                if (
                  !this.maintainStringValue &&
                  (this.templateId !== 999 &&
                    value.opts &&
                    this.activeValueType === V2ParameterValueType.ValueSet)
                ) {
                  if (insts.SelectedValue) {
                     this.selectedValueCache = _.cloneDeep(insts.SelectedValue);
                  }
                }
                if (value.eventKind === 0) {
                  insts.StringValue = value.sectionText;
                  insts.SelectedValue = null;
                }
                if (value.eventKind === 2) {
                  if (insts.ValueType === V2ParameterValueType.Bool) {
                    insts.BoolValue = this.ParameterInstanceFromValue(
                      insts,
                      value.sectionText
                    ).BoolValue;
                  } else if (insts.ValueType === V2ParameterValueType.Date) {
                    insts.DateValue = value.sectionText
                      ? new Date(value.sectionText)
                      : null;
                  }
                }
                committedInst = insts;
              }

              if (value.eventKind === 0) {
                if (this.activeValueType !== V2ParameterValueType.ValueSet || this.templateId === 999) {
                  this.clearCurrentPositionMark();
                }
              }
              this.$emit("update:modelValue", newParameters); // this.parameters

              // персист Bool/Date в edit на изменение: emit выше единственный, тут только запрос.
              if (
                value.eventKind === 2 &&
                committedInst &&
                (committedInst.ValueType === V2ParameterValueType.Bool ||
                  committedInst.ValueType === V2ParameterValueType.Date) &&
                committedInst.Id > 0
              ) {
                this.editFieldValueRequest(
                  committedInst.Id,
                  this.getEditRequest(committedInst)
                );
              }
            // }
          }
        }
      });
    } else {
      this.$emit("update:nested", value);
    }
  }

  clearCurrentPositionMark() {
    // no need to clear the Vendor code if templateId === 999
    if (this.isRoot) {
      const newParameters = reactive(_.cloneDeep(this.parameters));

      if (this.templateId !== 999) {
        this.componentModel.vendorCode = "";
        if (
          newParameters &&
          newParameters[0] &&
          newParameters[0].Instance
        ) {
          newParameters[0].Instance.StringValue = "";
          this.$emit("update:modelValue", newParameters); // this.parameters
        }
      }

      this.currentStoragePos = {
        currentPosId: 0,
        currentPosPrice: 0,
        currentPosPriceType: 0,
        currentPosUnit: 0,
        currentPosStorages: [],
      };
      this.$emit("storagePosChange", this.currentStoragePos);
    }
  }

  private getEditRequest(insts: ParameterInstance) {
    switch (insts.ValueType) {
      case V2ParameterValueType.String:
        return {
          StringValue: insts.StringValue || '',
        };
      case V2ParameterValueType.Int:
        // приоритет уже сохранённого NumberValue; иначе парсим текущий текст.
        // после сохранения StringValue пуст, число живёт в NumberValue
        return {
          NumberValue:
            insts.NumberValue ??
            (isNumeric(insts.StringValue + "")
              ? +parseInt("" + insts.StringValue)
              : null),
        };
      case V2ParameterValueType.Double:
        return {
          NumberValue:
            insts.NumberValue ??
            (isNumericFloat(insts.StringValue + "")
              ? +parseFloat(("" + insts.StringValue).replace(",", "."))
              : isNumeric(insts.StringValue + "")
              ? +parseInt("" + insts.StringValue)
              : null),
        };
      case V2ParameterValueType.Bool:
        return {
          BoolValue: insts.BoolValue ?? null,
        };
      case V2ParameterValueType.Date:
        // элементарная дата живёт в DateValue, StringValue для неё не заполняется;
        // new Date("").toISOString() бросил бы RangeError
        return {
          DateValue: insts.DateValue
            ? new Date(insts.DateValue).toISOString()
            : null,
        };
      case V2ParameterValueType.ValueSet:
        if (!insts.ValueSet) {
          return {
            SelectedValueId: null,
          };
        } else if (insts.SelectedValue?.Id) {
          return {
            SelectedValueId: insts.SelectedValue.Id || null,
          };
        } else if (insts.SelectedValue?.Name || insts.StringValue) {
          switch (insts.ValueSet.ValueType) {
            case V2ParameterValueSet_ValueType.String:
              return {
                NewCreatedValue: {
                  NameString: insts.SelectedValue?.Name || insts.StringValue,
                },
              };
            // falls through
            case V2ParameterValueSet_ValueType.Int:
              return {
                NewCreatedValue: {
                  NameNumber: isNumeric(
                    (insts.SelectedValue?.Name || insts.StringValue) + ""
                  )
                    ? +parseInt(
                        "" + (insts.SelectedValue?.Name || insts.StringValue)
                      )
                    : null,
                },
              };
            case V2ParameterValueSet_ValueType.Decimal:
              return {
                NewCreatedValue: {
                  NameNumber: isNumericFloat(
                    (insts.SelectedValue?.Name || insts.StringValue) + ""
                  )
                    ? +parseFloat(
                        (
                          "" + (insts.SelectedValue?.Name || insts.StringValue)
                        ).replace(",", ".")
                      )
                    : isNumeric(
                        (insts.SelectedValue?.Name || insts.StringValue) + ""
                      )
                    ? +parseInt(
                        "" + (insts.SelectedValue?.Name || insts.StringValue)
                      )
                    : null,
                },
              };
            case V2ParameterValueSet_ValueType.Date:
              return {
                NewCreatedValue: {
                  NameDate: new Date(
                    (insts.SelectedValue?.Name || insts.StringValue) + ""
                  ).toISOString(),
                },
              };
            default:
              return null;
          }
        } else {
          return {
            SelectedValue: null,
          };
        }
      default:
        return null;
    }
  }

  // Определяет, является ли вхождение с данным Id полем записи (лежит внутри RecordFields)
  // или верхнеуровневым параметром. Признак структурный - от isRoot не зависит.
  private isRecordFieldInstance(id: number): boolean {
    const search = (
      containers: ParameterInstanceContainer[],
      insideRecord: boolean
    ): boolean | null => {
      for (const p of containers) {
        if (
          p.Type === ParameterInstanceContainerType.SingleInstance &&
          p.Instance
        ) {
          const inst = p.Instance;
          if (inst.Id === id) return insideRecord;
          if (
            inst.ValueType === V2ParameterValueType.Record &&
            inst.RecordFields?.length
          ) {
            const r = search(inst.RecordFields, true);
            if (r !== null) return r;
          }
        } else if (
          p.Type === ParameterInstanceContainerType.List &&
          p.ListTitle
        ) {
          for (const inst of p.ListTitle.Instances) {
            if (!inst) continue;
            if (inst.Id === id) return insideRecord;
            if (
              inst.ValueType === V2ParameterValueType.Record &&
              inst.RecordFields?.length
            ) {
              const r = search(inst.RecordFields, true);
              if (r !== null) return r;
            }
          }
        }
      }
      return null;
    };
    return search(this.parameters, false) === true;
  }

  private async editFieldValueRequest(id: number, value: any) {
    if (this.createMode) {
      return;
    }
    // поле записи -> field-value, верхнеуровневой параметр -> parameter-value
    if (this.isRecordFieldInstance(id)) {
      await this.parameter_store.editField(id, value);
    } else {
      await this.parameter_store.editParameterValue(id, value);
    }
  }

  private createSchema(
    params: ParameterInstanceContainer[],
    indexPrefix: string = ""
  ): SchemaField[] {
    const schema: SchemaField[] = [];

    params.forEach((param) => {
      const ttl = param.ListTitle;
      const insts = param.Instance;
      if (param.Type === ParameterInstanceContainerType.List && ttl) {
        // take the 1st instance as they should be the same structure in the list
        const firstInstance = ttl.Instances[0];
        const templateId = firstInstance?.TemplateId;
        const nestedSchema = ttl.Instances.map((item, nestedIndex) => {
          const newPrefix = indexPrefix + nestedIndex;
          return this.ParameterInstanceToSchemaField(
            item,
            `param_${templateId}_${newPrefix}`,
            ttl.Name
          );
        });

        schema.push(
          this.ParameterInstanceToSchemaField(
            undefined,
            `param_${templateId}_${indexPrefix}arr`,
            "",
            nestedSchema,
            ttl.Id
          )
        );
        // console.log('push arr '+`param_${templateId}_${indexPrefix}arr`)
        // console.log(param)
      } else if (insts) {
        const templateId = insts.TemplateId;
        schema.push(
          this.ParameterInstanceToSchemaField(
            insts,
            `param_${templateId}_${indexPrefix}`,
            "",
            undefined
          )
        );
      }
    });

    return schema;
  }

  private getTypeFromValueType(valueType: V2ParameterValueType): string {
    switch (valueType) {
      case V2ParameterValueType.String:
        return "string";
      case V2ParameterValueType.Int:
        return "int";
      case V2ParameterValueType.Double:
        return "double";
      // case V2ParameterValueType.Date:
      // return "date";
      case V2ParameterValueType.ValueSet:
        return "select";
      case V2ParameterValueType.Record:
      case V2ParameterValueType.Bool:
      case V2ParameterValueType.Date:
        return "nested";
      default:
        return "string";
    }
  }

  private getInputPatternFromValueType(
    valueType: V2ParameterValueType,
    valueSetType: V2ParameterValueSet_ValueType
  ): RegExp | undefined {
    switch (valueType) {
      case V2ParameterValueType.String:
        return undefined;
      case V2ParameterValueType.Int:
        return /^[0-9]+$/;
      case V2ParameterValueType.Double:
        return /[0-9.]/;
      case V2ParameterValueType.ValueSet:
        switch (valueSetType) {
          case V2ParameterValueSet_ValueType.Int:
            return /^[0-9]+$/;
          case V2ParameterValueSet_ValueType.Decimal:
            return /[0-9.]/;
          default:
            return undefined;
        }
      default:
        return undefined;
    }
  }

  createModelValue(
    params: ParameterInstanceContainer[],
    indexPrefix: string = "",
    modelValue: Record<string, any> = {}
  ): Record<string, any> {
    params.forEach((param) => {
      const ttl = param.ListTitle;
      const insts = param.Instance;
      if (
        param.Type === ParameterInstanceContainerType.List &&
        ttl &&
        ttl.Instances.length
      ) {
        // take the 1st instance as they should be the same structure in the list
        const firstInstance = ttl.Instances[0];
        const templateId = firstInstance.TemplateId;

        const key = `param_${templateId}_${indexPrefix}arr`;
        if (
          firstInstance.ValueType === V2ParameterValueType.Record &&
          firstInstance.RecordFields
        ) {
          modelValue[key] = ttl.Instances.map(
            (item) => item.RecordFields || []
          );
        } else if (
          firstInstance.ValueType === V2ParameterValueType.Bool ||
          firstInstance.ValueType === V2ParameterValueType.Date
        ) {
          modelValue[key] = ttl.Instances;
        } else {
          const nestedModel = ttl.Instances.map((item) => {
            // use any item here as they should be always equal to the first one concerning structure
            const value = this.ParameterInstanceToValue(item);
            const tokens = (value.match(/(\s+|[^\s]+)/g) || []).map(
              (tok, index) => ({
                text: tok,
                type: "string",
                clickable: item.ValueType === V2ParameterValueType.ValueSet,
              })
            );
            const fullTokens: Token[] = [];
            tokens.forEach((token, index) => {
              if (/\s+/.test(token.text)) {
                fullTokens.push({ text: " ", type: "space", clickable: false });
              } else {
                fullTokens.push(token);
              }
            });
            return fullTokens;
          });
          modelValue[key] = nestedModel;
        }
      } else if (
        insts &&
        insts.ValueType === V2ParameterValueType.Record &&
        insts.RecordFields
      ) {
        const templateId = insts.TemplateId;
        const key = `param_${templateId}_${indexPrefix}`;
        modelValue[key] = insts.RecordFields;
      } else if (
        insts &&
        (insts.ValueType === V2ParameterValueType.Bool ||
          insts.ValueType === V2ParameterValueType.Date)
      ) {
        const templateId = insts.TemplateId;
        const key = `param_${templateId}_${indexPrefix}`;
        modelValue[key] = insts;
      } else if (insts) {
        const value = this.ParameterInstanceToValue(insts);

        const tokens = (value.match(/(\s+|[^\s]+)/g) || []).map(
          (tok: string, index: number) => ({
            text: tok,
            type: "string",
            clickable: insts.ValueType === V2ParameterValueType.ValueSet,
          })
        );
        const fullTokens: Token[] = [];
        tokens.forEach((token: Token, index: number) => {
          if (/\s+/.test(token.text)) {
            fullTokens.push({ text: " ", type: "space", clickable: false });
          } else {
            fullTokens.push(token);
          }
        });
        const templateId = insts.TemplateId;
        const key = `param_${templateId}_${indexPrefix}`;
        modelValue[key] = fullTokens;
      }
    });

    return modelValue;
  }

  private updateParamsFromModel(
    params: ParameterInstanceContainer[],
    newModel: Record<string, any>,
    indexPrefix: string = ""
  ) {
    params.forEach((param) => {
      const ttl = param.ListTitle;
      const insts = param.Instance;

      const templateId =
        param.Type === ParameterInstanceContainerType.List &&
        ttl &&
        ttl.Instances.length
          ? ttl.Instances[0].TemplateId
          : insts?.TemplateId;
      const key =
        param.Type === ParameterInstanceContainerType.List
          ? `param_${templateId}_${indexPrefix}arr`
          : `param_${templateId}_${indexPrefix}`;
      if (newModel[key]) {
        if (
          param.Type === ParameterInstanceContainerType.List &&
          ttl &&
          ttl.Instances.length
        ) {
          // take the 1st instance as they should be the same structure in the list
          const firstInstance = ttl.Instances[0];
          if (
            firstInstance.ValueType === V2ParameterValueType.Record &&
            firstInstance.RecordFields
          ) {
            ttl.Instances.forEach((item, nestedIndex) => {
              item.RecordFields = newModel[key][nestedIndex] || [];
            });
          } else if (
            firstInstance.ValueType === V2ParameterValueType.Bool ||
            firstInstance.ValueType === V2ParameterValueType.Date
          ) {
            ttl.Instances.forEach((item, nestedIndex) => {
              // пишем обратно в элемент списка по индексу, присваивание в локальную item было no-op
              ttl.Instances[nestedIndex] = newModel[key][nestedIndex] || item;
            });
          } else {
            ttl.Instances = ttl.Instances.map((item, nestedIndex) => {
              if (
                newModel[key][nestedIndex] &&
                Array.isArray(newModel[key][nestedIndex])
              ) {
                return this.ParameterInstanceFromValue(
                  item,
                  newModel[key][nestedIndex]
                    .map((token: any) => token.text)
                    .join("")
                );
              } else {
                return item;
              }
            });
          }
        } else if (
          insts &&
          insts.ValueType === V2ParameterValueType.Record &&
          insts.RecordFields
        ) {
          insts.RecordFields = newModel[key] || [];
        } else if (
          insts &&
          (insts.ValueType === V2ParameterValueType.Bool ||
            insts.ValueType === V2ParameterValueType.Date)
        ) {
          param.Instance = newModel[key] || null;
        } else if (insts) {
          if (newModel[key] && Array.isArray(newModel[key])) {
            param.Instance = this.ParameterInstanceFromValue(
              insts,
              newModel[key].map((token: any) => token.text).join("")
            );
          }
        }
      }
    });
  }

  closeMenu() {
    const that = this;
    this.$nextTick(() => {
      const inlineDescriptor = that.$refs["inlineDescriptor" + that.id] as any;
      if (inlineDescriptor) {
        inlineDescriptor.hideMenu();
        this.componentModel.container = null;
      }
    });
  }

  // when the model is saved
  onUpdateModelValue(newModel: Record<string, any>) {
    const newParameters = reactive(_.cloneDeep(this.parameters));
    this.updateParamsFromModel(newParameters, newModel, this.indexPrefix);
    this.$emit("update:modelValue", newParameters); // this.parameters
  }

  /**
   * Возвращает кнопки списка в рабочее состояние после запроса. Описатель блокирует
   * нажатую кнопку и показывает индикацию, а сам снимает их только при пересборке
   * разметки, которой при неудачном запросе не будет.
   */
  private releaseListActionState(): void {
    const inlineDescriptor = this.$refs["inlineDescriptor" + this.id] as any;
    inlineDescriptor?.clearListActionState?.();
  }

  async addListItem(arg: {
    templateId: number;
    instanceId: number | undefined;
  }) {
    try {
      await this.applyAddListItem(arg);
    } finally {
      this.releaseListActionState();
    }
  }

  private async applyAddListItem({
    templateId,
    instanceId,
  }: {
    templateId: number;
    instanceId: number | undefined;
  }) {
    const newParameters = reactive(_.cloneDeep(this.parameters));
    console.log("add list item " + templateId + " " + instanceId);
    // otherwise copy first list instance to an empty structure
    const templateParamIndex = newParameters.findIndex(
      (p) =>
        p.Type === ParameterInstanceContainerType.List &&
        p.ListTitle?.Instances[0]?.TemplateId === templateId
    );
    const ttl = newParameters[templateParamIndex]?.ListTitle;

    if (templateParamIndex >= 0 && ttl && ttl.Instances.length) {
      // dont use API when the whole container is supposed to be a new item;
      // otherwise there is a risk of damaging existing parameters from the custom hints
      if (instanceId && !this.createMode) {
        // make API call
        const newParam = (
          await this.parameter_store.addListField(instanceId, !this.isRoot)
        ).Instance;

        // Вставляем новый элемент после последнего с таким templateId
        ttl.Instances.push(newParam || _.cloneDeep(ttl.Instances[0]));
      } else {
        // otherwise just push an empty parameter based on the first instance structure
        // TODO: make empty element based on this structure
        const newParam: ParameterInstance = createEmptyFromInstance(
          ttl.Instances[0],
          (instanceId || 0) + 1 + 1000
        ); // _.cloneDeep(ttl.Instances[0]);
        // newParam.StringValue = "";

        // if (
        // newParam.ValueType === V2ParameterValueType.Record &&
        // newParam.RecordFields
        // ) {
        // TODO: mapRecursive here creating empty structures based on the first elements of all nested lists and records
        // newParam.RecordFields = [];
        // } else {
        // newParam.RecordFields = [];
        // }
        // Вставляем новый элемент после последнего с таким templateId
        ttl.Instances.push(newParam);
      }
    }

    this.clearCurrentPositionMark();
    this.$emit("update:modelValue", newParameters);
  }

  async removeListItem(arg: {
    templateId: number;
    instanceId: number | undefined;
    index: number;
  }) {
    try {
      await this.applyRemoveListItem(arg);
    } finally {
      this.releaseListActionState();
    }
  }

  private async applyRemoveListItem({
    templateId,
    instanceId,
    index,
  }: {
    templateId: number;
    instanceId: number | undefined;
    index: number;
  }) {
    const newParameters = reactive(_.cloneDeep(this.parameters));
    // else just remove item at index
    console.log("remove item " + templateId + " - " + index);
    const templateParam = newParameters.find(
      (p) =>
        p.Type === ParameterInstanceContainerType.List &&
        p.ListTitle?.Instances[0]?.TemplateId === templateId
    );
    const ttl = templateParam?.ListTitle;
    if (templateParam && ttl) {
      // dont use API when the whole container is supposed to be a new item;
      // otherwise there is a risk of damaging existing parameters from the custom hints
      if (instanceId && !this.createMode) {
        // make API call
        await this.parameter_store.removeListField(instanceId, !this.isRoot);
      }
      ttl.Instances.splice(index, 1);
    }
    this.clearCurrentPositionMark();
    this.$emit("update:modelValue", newParameters); // this.parameters
  }

  customUpdateToken(token: Token, field: SchemaField): Token {
    // Адаптировать для типов параметров, если нужно
    return token;
  }

  // mapping helper functions

  private ParameterInstanceToSchemaField(
    item: ParameterInstance | undefined,
    key: string,
    title: string,
    nestedSchema: SchemaField[] | undefined = undefined,
    listId: number | undefined = undefined
  ): SchemaField {
    return {
      key,
      // Устойчивый признак единицы это вхождение, у списочного поля его роль играет
      // сам список. У только что добавленного элемента вхождения ещё нет, тогда
      // остаётся позиционный ключ поля и единица переживёт ответ сервера пересборкой
      unitKey:
        item && item.Id > 0
          ? `inst_${item.Id}`
          : listId
          ? `list_${listId}`
          : key,
      title,
      axis:
        item && item.RecordAxisType === V2RecordAxisType.Vertical
          ? "vertical"
          : "horizontal",
      type: item ? this.getTypeFromValueType(item.ValueType) : "",
      // Formula - только просмотр: секция станет нередактируемой через forbid_edit
      readonly: item ? item.ValueType === V2ParameterValueType.Formula : false,
      inputPattern: item
        ? this.getInputPatternFromValueType(
            item.ValueType,
            item.ValueSet?.ValueType || V2ParameterValueSet_ValueType.String
          )
        : undefined,
      options: item
        ? 
          [
            {
              InstanceId: item.Id,
              ValueType: item.ValueType,
              ValueSet: item.ValueSet,
              TemplateId: item.TemplateId,
              selectedId: item.SelectedValue?.Id,
            },
          ]
        : nestedSchema && nestedSchema.length
        ? [
            {
              InstanceId: listId,
              TemplateId:
                nestedSchema[0].options && nestedSchema[0].options.length
                  ? nestedSchema[0].options[0].TemplateId
                  : undefined,
            },
          ]
        : undefined,
      separator: item ? this.separators[0] : undefined,
      nestedSchema,
      allowDelete: false,
      prefix: undefined,
      isList: nestedSchema && nestedSchema.length ? true : false,
      placeholder: item ? item.Name : "",
      component:
        item && item.ValueType === V2ParameterValueType.Record
          ? this.$options.components?.ParameterInline
          : item && item.ValueType === V2ParameterValueType.Bool
          ? this.$options.components?.ParameterCheckbox
          : item && item.ValueType === V2ParameterValueType.Date
          ? this.$options.components?.ParameterDateField
          : undefined,
    };
  }

  private ParameterInstanceToValue(param: ParameterInstance): string {
    switch (param.ValueType) {
      case V2ParameterValueType.String:
        return param.StringValue || "";
      case V2ParameterValueType.Int:
      case V2ParameterValueType.Double:
        // при null поле должно быть пустым; 0 показываем как "0"
        return param.NumberValue != null ? "" + param.NumberValue : "";
      case V2ParameterValueType.Formula:
        return param.NumberValue ? "" + param.NumberValue : "";
      case V2ParameterValueType.Bool:
        return param.BoolValue != null
          ? param.BoolValue
            ? "true"
            : "false"
          : "null";
      case V2ParameterValueType.Date:
        return param.DateValue ? "" + param.DateValue : "";
      case V2ParameterValueType.ValueSet:
        switch (param.ValueSet?.ValueType) {
          case V2ParameterValueSet_ValueType.String:
          // falls through
          case V2ParameterValueSet_ValueType.Int:
          case V2ParameterValueSet_ValueType.Decimal:
            return param.SelectedValue?.Name || param.StringValue || "";
          case V2ParameterValueSet_ValueType.Date:
            return param.SelectedValue?.Name
              ? /*date.formatDate(
                  new Date("" + param.SelectedValue?.Name),
                  "DD.MM.YY"
                ) || "" */ "" + param.SelectedValue?.Name
              : param.StringValue || "";
          default:
            return param.StringValue || "";
        }
      default:
        return "";
    }
  }

  private ParameterInstanceFromValue(
    containerValue: ParameterInstance,
    fieldModel: any
  ): ParameterInstance {
    let res_value = {
      Id: containerValue.Id,
      Name: containerValue.Name,
      TemplateId: containerValue.TemplateId,
      Unremovable: containerValue.Unremovable,
      ValueDisplayType: containerValue.ValueDisplayType,
      ValueType: containerValue.ValueType,
      ValueSet: containerValue.ValueSet,
      RecordAxisType: containerValue.RecordAxisType,
      Round: containerValue.Round,
      RecordFields: containerValue.RecordFields,
    } as ParameterInstance;

    switch (containerValue.ValueType) {
      case V2ParameterValueType.String:
        res_value.StringValue = fieldModel || '';
        break;
      case V2ParameterValueType.Int:
        res_value.NumberValue = isNumeric(fieldModel) ? +fieldModel : null;
        break;
      case V2ParameterValueType.Double:
      case V2ParameterValueType.Formula:
        res_value.NumberValue = isNumericFloat(fieldModel) ? +fieldModel : null;
        break;
      case V2ParameterValueType.Bool:
        res_value.BoolValue =
          fieldModel === "true" ? true : fieldModel === "false" ? false : null;
        break;
      case V2ParameterValueType.Date:
        res_value.DateValue = date.extractDate(
          fieldModel,
          "DD.MM.YY",
          undefined
        );
        break;
      case V2ParameterValueType.ValueSet:
        res_value.SelectedValue = {
          Id: containerValue.SelectedValue?.Id,
          Name: fieldModel || "",
        };
        break;
      default:
        break;
    }
    return res_value;
  }
}
</script>
<style scoped>
ul {
  list-style: none;
  padding: 0;
  margin: 0;
  min-width: 150px;
  max-width: fit-content;
}

li {
  padding: 8px;
  cursor: pointer;
}

li:hover {
  background: #f0f0f0;
}

/* Контейнер подсказки: высота 100% fmenu, ширина по контенту — при переполнении скроллится вся .fmenu */
.parameter-inline-menu-row {
  height: 100%;
  max-height: 100%;
  width: max-content;
  min-width: 100%;
  overflow: visible;
  display: flex;
}

/* Только в этой подсказке при двух блоках без данных — контент не схлопывается; не больше 100%, чтобы влезало в fmenu */
.parameter-inline-menu-row--min-height-when-empty {
  min-height: min(360px, 100%);
}

.parameter-inline-menu-col {
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

/* Заголовок столбца: высота 40px, контент по верху — левая кнопка и правая надпись выровнены */
.parameter-inline-menu-col__header {
  flex: 0 0 auto;
  height: 40px;
  min-height: 40px;
  box-sizing: border-box;
  display: flex;
  align-items: flex-start;
}

/* Кнопка «Добавить/Удалить» слева: компактная по высоте, надпись по центру кнопки (перебиваем общую высоту заголовка) */
.parameter-inline-menu-col__header.parameter-inline-menu-col__header--btn {
  cursor: pointer;
  min-height: 28px !important;
  height: 28px !important;
  padding: 0 12px;
  margin: 8px 8px;
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  border: 1px solid #bdbdbd;
  border-radius: 4px;
  font-size: 0.875rem;
  font-weight: 500;
  line-height: 1.25;
  transition: background-color 0.15s ease;
  box-sizing: border-box;
  max-width: calc(100% - 16px);
  &:hover {
    background-color: rgba(0, 0, 0, 0.04);
  }
}

.parameter-inline-menu-col__header-text {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: 0;
}

/* Надпись «Позиции:» — некликабельная, отступ сверху чтобы совпала по вертикали с текстом кнопки, жирная */
.parameter-inline-menu-col__header--static {
  pointer-events: none;
  padding: 12px 0 0 8px;
  line-height: 1.25;
  font-size: 0.875rem;
  font-weight: bold;
}

/* Обёртка под aux-selector: забирает оставшуюся высоту, скролл только внутри селектора */
.parameter-inline-menu-col__selector {
  flex: 1 1 0;
  min-height: 0;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

/* В левом блоке селектор явно ограничен по высоте: минус высота заголовка (40px), чтобы влезал в fmenu */
.parameter-inline-menu-col--left .parameter-inline-menu-col__selector {
  height: calc(100% - 40px);
  max-height: calc(100% - 40px);
  flex: 0 0 auto;
  overflow: hidden;
}

/* Когда слева нет кнопки (998) — обёртка на всю высоту, отступ снизу меньше */
.parameter-inline-menu-col--left-no-header .parameter-inline-menu-col__selector {
  height: 100%;
  max-height: 100%;
}

/* В правом блоке то же: минус высота надписи «Позиции:» (40px), оба столбца выровнены по высоте */
.parameter-inline-menu-col__selector--right {
  height: calc(100% - 40px);
  max-height: calc(100% - 40px);
  flex: 0 0 auto;
  overflow: hidden;
}

/* Левый блок: высота 100% строки; min/max ширина для выпадающего меню; скролл только внутри aux-selector */
.parameter-inline-menu-col--left {
  flex: 0 1 300px;
  min-width: 300px;
  max-width: min(33.333%, 320px);
  height: 100%;
  min-height: 0;
  word-wrap: break-word;
  white-space: normal;
}

/* Правый блок: ширина по контенту, при переполнении скроллится вся .fmenu */
.parameter-inline-menu-col--right {
  flex: 0 0 auto;
  width: min-content;
  min-width: 0;
}

</style>
